export class GeneralUtil {
  static toMoney(amount: number) {
    return new Intl.NumberFormat('de-DE').format(amount)
  }
}
